<layout>
  <div class="headerImage">
    <div class="vert">

      <h1 class="h1">{{config?.understandTheBible}}</h1>
      <span class="sub">{{config?.imageHeaderBody}}</span>
      <div class="hori">
        <gradient-button (click)="register()">{{config?.mainStartButton}}</gradient-button>
        <span class="hori-inner">
          <!-- <text-button routerLink="">{{config?.watchVideo}}</text-button> -->
          <!-- <div class="divider"></div> -->
          <text-button *ngIf="!profile?.uid" routerLink="/lesson/1">{{config?.tryDemo}}</text-button>
          <text-button *ngIf="!!profile?.uid" routerLink="/my-lessons">{{config?.myLessonsTitle}}</text-button>
      </span>
    </div>
    </div>
  </div>	
</layout>
